module.exports = __webpack_public_path__ + "img/Weapon_155.a6e665fa.png";